import { Typography } from "@mui/material";

const Title = (props) => {
  return (
    <>
      <Typography          
        variant="h3"
        component="h1"
        sx={{
          fontWeight: "bold",
          fontSize: "3",
          mt: "2rem",
        }}
      >
        {props.text}
      </Typography>
      <Typography          
        variant="h6"
      >
        {props.date}
      </Typography>
    </>
  )
}

export default Title;